var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"div",staticClass:"ys-float-btn",style:({
    width: _vm.itemWidth + 'px',
    height: _vm.itemHeight + 'px',
    left: _vm.left + 'px',
    top: _vm.top + 'px',
  }),on:{"click":_vm.onBtnClicked}},[_vm._t("icon",function(){return [_c('svg-icon',{attrs:{"iconClass":"other"}})]}),_vm._t("text",function(){return [_c('span',[_vm._v("我的订单")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }